import React from 'react';
import styled from 'styled-components';

interface Props {
  data: {
    title: string;
    content: string[];
  }[];
  moreSection?: {
    title: string;
    content: string[];
  }[];
}

function LandingFooter({ data, moreSection }: Props) {
  return (
    <FooterContainer>
      {data.map((item, idx) => (
        <React.Fragment key={idx}>
          <FooterTitle>{item.title}</FooterTitle>
          <FooterDescription>
            {item.content.map((desc, idx2) => (
              <FooterDescriptionItem key={idx2}>
                <div>・</div>
                {desc}
              </FooterDescriptionItem>
            ))}
          </FooterDescription>
        </React.Fragment>
      ))}

      {moreSection && (
        <MoreSection>
          {moreSection.map((item, idx) => (
            <React.Fragment key={idx}>
              <MoreSectionTitle>{item.title}</MoreSectionTitle>
              <FooterDescription>
                {item.content.map((desc, idx2) => (
                  <FooterDescriptionItem key={idx2}>
                    <div>・</div>
                    {desc}
                  </FooterDescriptionItem>
                ))}
              </FooterDescription>
            </React.Fragment>
          ))}
        </MoreSection>
      )}
    </FooterContainer>
  );
}

export default LandingFooter;

const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 60px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  background: #1f1f1f;
`;

const FooterTitle = styled.div`
  font-family: Paperlogy;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
  color: #ffffff;
`;

const FooterDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
`;

const FooterDescriptionItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;

  color: #b0b0b0;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
  white-space: pre-line;
`;

const MoreSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const MoreSectionTitle = styled.div`
  color: #fff;
  font-family: Paperlogy;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
